/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Category_PerformanceInputs */

const en_interview_practice_category_performance = /** @type {(inputs: Interview_Practice_Category_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance by Category`)
};

const de_interview_practice_category_performance = /** @type {(inputs: Interview_Practice_Category_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistung nach Kategorie`)
};

const fr_interview_practice_category_performance = /** @type {(inputs: Interview_Practice_Category_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance par catégorie`)
};

const es_interview_practice_category_performance = /** @type {(inputs: Interview_Practice_Category_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento por categoría`)
};

const it_interview_practice_category_performance = /** @type {(inputs: Interview_Practice_Category_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestazioni per categoria`)
};

const nl_interview_practice_category_performance = /** @type {(inputs: Interview_Practice_Category_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestaties per categorie`)
};

const pl_interview_practice_category_performance = /** @type {(inputs: Interview_Practice_Category_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyniki według kategorii`)
};

const fi_interview_practice_category_performance = /** @type {(inputs: Interview_Practice_Category_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suorituskyky kategorioittain`)
};

const da_interview_practice_category_performance = /** @type {(inputs: Interview_Practice_Category_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance efter kategori`)
};

const sv_interview_practice_category_performance = /** @type {(inputs: Interview_Practice_Category_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestanda per kategori`)
};

/**
* | output |
* | --- |
* | "Performance by Category" |
*
* @param {Interview_Practice_Category_PerformanceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_category_performance = /** @type {((inputs?: Interview_Practice_Category_PerformanceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Category_PerformanceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_category_performance(inputs)
	if (locale === "fr") return fr_interview_practice_category_performance(inputs)
	if (locale === "es") return es_interview_practice_category_performance(inputs)
	if (locale === "it") return it_interview_practice_category_performance(inputs)
	if (locale === "nl") return nl_interview_practice_category_performance(inputs)
	if (locale === "pl") return pl_interview_practice_category_performance(inputs)
	if (locale === "fi") return fi_interview_practice_category_performance(inputs)
	if (locale === "da") return da_interview_practice_category_performance(inputs)
	if (locale === "sv") return sv_interview_practice_category_performance(inputs)
	return en_interview_practice_category_performance(inputs)
});